import { getBranchId } from '@/shared/config/funnel/utils/client';

export type SurvicateCardFinderTraits = {
  page_name: string;
  page_branch_name: string;
  page_funnel_step: string;
  is_authenticated: string;
  experiment_variant: string;
};

export function buildSurvicateCardFinderTraits(input: {
  pageName: string;
  branchSlug?: string;
  stepSlug?: string;
  isLoggedIn: boolean;
  experimentDecision?: string;
}): SurvicateCardFinderTraits {
  return {
    page_name: input.pageName,
    page_branch_name: input.branchSlug ? getBranchId(input.branchSlug) : '',
    page_funnel_step: input.stepSlug ?? '',
    is_authenticated: input.isLoggedIn ? 'true' : 'false',
    experiment_variant: input.experimentDecision ?? '',
  };
}
